import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProjectAsyncPipe} from './project-async.pipe';

@NgModule({
  declarations: [ProjectAsyncPipe],
  imports: [CommonModule],
  exports: [ProjectAsyncPipe],
  providers: [ProjectAsyncPipe]
})
export class ProjectAsyncModule {}
